import { Text, View } from "@react-pdf/renderer";

import {
  POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS,
  PotentialAreasOfConcern,
} from "~/providers/utils/types/patientPreviewTypes";

const SUGGESTION_TO_SWATCH_MAP = {
  [POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS.direct_report_skew]: {
    primary: "#323539",
    secondary: "#EAEBF0",
  },
  [POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS.personality_pathology]: {
    primary: "#203742",
    secondary: "#C2E4F5",
  },
  [POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS.impulsivity]: {
    primary: "#363F67",
    secondary: "#C8D0F9",
  },
  [POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS.eating_disorder]: {
    primary: "#5E406D",
    secondary: "#F0D2FF",
  },
  [POTENTIAL_AREAS_OF_CONCERN_SUGGESTIONS.substance_use]: {
    primary: "#2433A8",
    secondary: "#C1D4FB",
  },
};

export const ConsultationExportSummaryConcerns = ({
  concerns,
}: {
  concerns: PotentialAreasOfConcern[];
}) => {
  if (!concerns.length) return null;

  return (
    <View style={{ border: "1px solid #C1C3C7", borderRadius: 6 }}>
      <View
        style={{
          flexDirection: "row",
          paddingVertical: 8,
          paddingHorizontal: 16,
          borderBottomWidth: 1,
          borderBottomColor: "#C1C3C7",
          backgroundColor: "#F0F4FE",
          borderTopLeftRadius: 6,
          borderTopRightRadius: 6,
        }}
      >
        <View style={{ width: "50%" }}>
          <Text style={{ color: "#2433A8" }}>Flag</Text>
        </View>
        <View style={{ width: "50%" }}>
          <Text style={{ color: "#2433A8" }}>May suggest</Text>
        </View>
      </View>

      {concerns.map((poc, i) => (
        <View
          style={{
            flexDirection: "row",
            paddingVertical: 8,
            paddingHorizontal: 16,
            borderBottomWidth: i === concerns.length - 1 ? 0 : 1,
            borderBottomColor: "#C1C3C7",
          }}
          key={i}
          wrap={false}
        >
          <View style={{ width: "50%" }}>
            <Text>{poc.flag}</Text>
          </View>
          <View
            style={{
              width: "50%",
              flexDirection: "row",
              flexWrap: "wrap",
              gap: 4,
            }}
          >
            {poc.suggestions.map((suggestion, j) => (
              <Text
                style={{
                  backgroundColor:
                    SUGGESTION_TO_SWATCH_MAP[suggestion].secondary,
                  color: SUGGESTION_TO_SWATCH_MAP[suggestion].primary,
                  paddingHorizontal: 8,
                  paddingVertical: 2,
                  borderRadius: 20,
                }}
                key={j}
              >
                {suggestion}
              </Text>
            ))}
          </View>
        </View>
      ))}
    </View>
  );
};
